import {
    allFetch
} from "../Domain";

/**
 * @description 交修項目
 */
export const TurnoverRepair = (() => {
    /**
     * @description 交修項目新建
     * @param {string} trs_code 交修項目代號
     * @param {string} trs_name 交修項目名稱
     * @param {string} note 備註
     */
    const TurnoverRepairCreate = async function (obj = {
        trs_code: '',
        trs_name: '',
        note: ''
    }) {
        return await allFetch('TurnoverRepair/TurnoverRepairCreate', obj);
    }

    /**
     * @description 交修項目查詢
     * @param {string} trs_code 交修項目代號
     * @param {string} trs_name 交修項目名稱
     * @param {string} visible 是否可見
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const TurnoverRepairSearch = async function (obj = {
        trs_code: '',
        trs_name: '',
        visible: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('TurnoverRepair/TurnoverRepairSearch', obj);
    }

    /**
     * @description 交修項目修改
     * @param {string} trs_id 交修項目流水號
     * @param {string} trs_code 交修項目代號
     * @param {string} trs_name 交修項目名稱
     * @param {string} note 備註
     * @param {string} visible 是否可見
     */
    const TurnoverRepairUpdate = async function (obj = {
        trs_id: '',
        trs_code: '',
        trs_name: '',
        note: '',
        visible: ''
    }) {
        return await allFetch('TurnoverRepair/TurnoverRepairUpdate', obj);
    }

    /**
     * @description 交修項目刪除
     * @param {string} trs_id 交修項目流水號
     */
    const TurnoverRepairDelete = async function (obj = {
        trs_id: '',
    }) {
        return await allFetch('TurnoverRepair/TurnoverRepairDelete', obj);
    }

    /**
     * @description 交修項目細項
     * @param {string} trs_id 交修項目流水號
     */
    const TurnoverRepairDetail = async function (obj = {
        trs_id: ""
    }) {
        return await allFetch('TurnoverRepair/TurnoverRepairDetail', obj);
    }
    return {
        TurnoverRepairCreate,
        TurnoverRepairSearch,
        TurnoverRepairUpdate,
        TurnoverRepairDelete,
        TurnoverRepairDetail
    }
})();